<template>
  <div class="tax-identifier-input">
    <a-input
      :value="value"
      :disabled="disabled"
      :placeholder="TAX_IDENTIFIER_PLACEHOLDER"
      v-mask="'###-##-####'"
      :masked="true"
      :autocomplete="autocomplete"
      v-bind="inputAttrs"
      @input="handleInput"
    />
    <a-button class="tax-identifier-input__action" type="link" :disabled="disabled" @click="toggleIdentifierType">
      {{ actionLabel }}
    </a-button>
  </div>
</template>

<script>
import { Button, Input } from 'ant-design-vue'
import { getTaxIdentifierActionLabel, isSsnIdentifier, TAX_IDENTIFIER_PLACEHOLDER } from '@/utils/tax-identifier'

export default {
  name: 'TaxIdentifierInput',
  components: {
    'a-input': Input,
    'a-button': Button
  },
  props: {
    value: {
      type: String,
      default: undefined
    },
    isSsn: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    inputAttrs: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      TAX_IDENTIFIER_PLACEHOLDER
    }
  },
  computed: {
    actionLabel() {
      return getTaxIdentifierActionLabel(this.isSsn)
    }
  },
  methods: {
    handleInput(event) {
      const value = event.target.value

      this.$emit('input', value)
      this.$emit('change', value)
    },
    toggleIdentifierType() {
      const nextIsSsn = !isSsnIdentifier(this.isSsn)

      this.$emit('update:isSsn', nextIsSsn)

      this.$nextTick(() => {
        this.$emit('change', this.value)
        this.$emit('type-change', nextIsSsn)
      })
    }
  }
}
</script>

<style scoped>
.tax-identifier-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.tax-identifier-input__action {
  height: auto;
  padding: 4px 0 0;
}
</style>
